module.exports = __webpack_public_path__ + "img/q2-5-active.bb58a1c9.png";